import _ from "lodash";

export const sumNumericColumns = (rows, colName) => {
  return rows.reduce((prevValue, curValue) => {
    let curFloat = _.get(curValue, colName);
    if (!curFloat) curFloat = 0;
    return prevValue + curFloat;
  }, 0);
};
